import React from "react";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import { CalenderIcon } from "../../../Icon";
import Select from "react-select";
import {
  BomHeaderErrorType,
  BomHeaderType,
  SelectOption,
} from "../../../../commonTypes/billOfMaterial";
import moment from "moment";
import { DropDown } from "../../../commons";
import { changeToDecimel, formatDate } from "../../../../utils/commonFunctions";

type AppProps = {
  option: any[];
  bomHeaderData: any;
  fetching: boolean;
  checkStockItemTypeBottom: () => void;
  setStockItemText:  React.Dispatch<React.SetStateAction<string>>;
  currencySign: string | undefined;
  templateId?:string;
  allStockItemOption: SelectOption[];
  bomHeaderError: BomHeaderErrorType;
  handlePrimaryDetails: (e: any, type: string) => void;
  setDateOfBom:any;
  allBatchOption:any;
  toggleAddBatchNumberModal:()=>void;
limit:number;
autoUniqueNumberGenerationData:any;
bomType:string|undefined;
setDropDownType: (data: string) => void;
dispatchResetMappedStockBatchList:()=>void;
handlePrimaryBatchOpen:()=>void;
batchFetching:boolean;
isMenuOpen:boolean;

  
};

const PrimaryDetails = ({
  bomHeaderData,
  handlePrimaryDetails,
  allStockItemOption,
  bomHeaderError,
  option,
  templateId,
  fetching,
  currencySign,
  checkStockItemTypeBottom,
  setStockItemText,
  setDateOfBom,
  allBatchOption,
  toggleAddBatchNumberModal,
  limit,
  autoUniqueNumberGenerationData,
  bomType,
  setDropDownType,
  dispatchResetMappedStockBatchList,
  handlePrimaryBatchOpen,
  batchFetching,
  isMenuOpen
}: AppProps) => {
  const checkBranchTypeBottom = () => {
    

  };
  return (
    <div className="row" style={{ marginBottom: "-10px" }}>
      <div className="col-md-2 form-group mt-3">
        <label htmlFor="SKU" className={true ? "active mb-1" : "mb-1"}>
          Document Number
        </label>
        <input
          type="text"
          className={"form-control"}
          name="by-product-percent"
          value={bomHeaderData?.documentNumber}
          disabled={true || templateId}
          autoFocus
          onChange={(e) => handlePrimaryDetails(e, "documentNumber")}
          maxLength={7}
          //   onInput={handleMaxLengthCheck}
          onWheel={(event) => event.currentTarget.blur()}
        />
      </div>

      <div className="col-md-2 form-group mt-3">
        <label className="mb-1" htmlFor="">
          Date
          <span className="color-red">*</span>
        </label>
        <div
          className={`form-group ${
            bomHeaderError?.dateError ? "error-border" : null
          }`}
        >
          <div className="date-picker-wraper mr-0">
            <Label className="m-0 p-0 w-100 d-flex">
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={
                  bomHeaderData?.date && bomHeaderData?.date !== "Invalid date"
                    ? new Date(
                        moment(
                          `${bomHeaderData?.date}T00:00:00`,
                          "YYYY-MM-DD"
                        ).format("YYYY-MM-DD[T]HH:mm:ss")
                      )
                    : null
                }
                onChange={(e: any) =>{
                  handlePrimaryDetails?.(
                    !e ? "" : moment(e).format("YYYY-MM-DD"),
                    "date"
                  )
                }
                  
                }
                fixedHeight
                disabled={!!templateId}
                showMonthDropdown
                showYearDropdown
                name="dateOfInvoice"
                placeholderText="Select Date"
                className="form-control pt-0 pb-0"
              />
              <span
                className="calender-icon"
                style={{ right: "22px", top: "35px", cursor: "pointer" }}
              >
                {" "}
                <CalenderIcon />
              </span>
            </Label>
          </div>
        </div>
      </div>

      <div className="col-md-2">
        <form>
          <div className="form-group mt-3">
            <div>
              <label className="mb-1" htmlFor="PrimaryItem">
                Primary Item
                <span className="color-red">*</span>
              </label>
              <Select<any, false>
                className={`react-select ${
                  bomHeaderError?.primaryItemError ? "error-border" : null
                }`}
                isDisabled={!bomHeaderData?.date || !!templateId}
                inputProps={{ autoComplete: "nope" }}
                options={
                  allStockItemOption
                    ? [{ label: "Select...", value: "" }, ...allStockItemOption]
                    : []
                }
                value={bomHeaderData?.primaryItem}
                onChange={(e: any) => handlePrimaryDetails?.(e, "primaryItem")}
                isSearchable
                isLoading={fetching}
                onMenuScrollToBottom={checkStockItemTypeBottom}
                onInputChange={(e) => {
                  setStockItemText(e);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      <div className="col-md-2">
        <form>
          <div className="form-group mt-3">
            <div>
              <label className="mb-1" htmlFor="BYPRODUCT">
                Branch
                <span className="color-red">*</span>
              </label>
              <DropDown
                disabled={!bomHeaderData?.date || !!templateId}
                extraClasses={`react-select ${
                  bomHeaderError?.branchError ? "error-border" : null
                }`}
                placeholder="Choose branch name..."
                options={
                  option ? [{ label: "Select...", value: "" }, ...option] : []
                }
                handleChange={(e: any) => handlePrimaryDetails?.(e, "branch")}
                value={bomHeaderData?.branch}
              />
            </div>
          </div>
        </form>
      </div>

      <div className="col-md-1 form-group mt-3">
        <label htmlFor="Qty" className={true ? "active mb-1" : "mb-1"}>
          Qty
          <span className="color-red">*</span>
        </label>
        <input
          type="number"
          className={`form-control ${
            bomHeaderError?.qtyError ? "error-border" : null
          }`}
          name="by-product-percent"
          value={bomHeaderData?.qty}
          disabled={!bomHeaderData?.date || !!templateId}
          autoFocus
          onChange={(e: any) => handlePrimaryDetails?.(e, "qty")}
          maxLength={7}
          onWheel={(event) => event.currentTarget.blur()}
        />
      </div>

      <div className="custom-col col mt-3">
        <label className="mb-1" htmlFor="">
          Rate
        </label>

        <div className="  mt-2 costOfInputHeader">
          {currencySign}{" "}
          {bomHeaderData?.rate ? (+bomHeaderData?.rate)?.toFixed(2) : 0}
        </div>
      </div>

      <div className="custom-col col mt-3">
        <label className="mb-1" htmlFor="">
          Amount
        </label>
        <div className="form-group mt-2 costOfInputHeader">
          {currencySign}{" "}
          {bomHeaderData?.amount ? changeToDecimel(+bomHeaderData?.amount) : 0}
        </div>
      </div>
      {/* batch */}
      {autoUniqueNumberGenerationData?.is_enable===1?
      <>
      <div className="col-md-2 mr-2 ml-1">
        <form>
          <div className="form-group mt-3">
            <div>
              <label className="mb-1" htmlFor="BYPRODUCT">
                Batch Number
               
              </label>
              <Select<any, false>
                className={`react-select ${
                  bomHeaderError?.primaryItemError ? "error-border" : null
                }`}
                isDisabled={!bomHeaderData?.date || !!templateId}
                inputProps={{ autoComplete: "nope" }}
                // options={
                //   allBatchOption
                //     ? [{ label: "Select...", value: "" }, ...allBatchOption]
                //     : []
                // }
                options={
                  batchFetching && isMenuOpen
                    ? [{ label: "Loading...", value: "" }]
                    : [{ label: "Select...", value: "" }, ...allBatchOption]
                }
                value={bomHeaderData?.batchNumber}
                onChange={(e: any) => handlePrimaryDetails?.(e, "batchNumber")}
                isSearchable
                isLoading={batchFetching}
                onMenuScrollToBottom={checkBranchTypeBottom}
                onInputChange={(e) => {
                  setStockItemText(e);
                }}
                onMenuOpen={() => {
                 
                  handlePrimaryBatchOpen()

                }}
              />
            </div>
          </div>
        </form>
        {bomType==="bomTemplate"?"":
        <p className="batchNumberAddPara" 
        onClick={toggleAddBatchNumberModal}
        >+ Add Batch Number if not exists</p>
}
      </div>

      <div className="col-md-2 ">
          <label className="mt-4">Manufacturing Date</label>
          <div className=" costOfInputHeader">
            {bomHeaderData?.batchNumber?.manufacturingDate ?formatDate(bomHeaderData?.batchNumber?.manufacturingDate ):"-"}
          </div>
      </div>

    
      <div className="col-md-2 ">

          <label className="mt-4">Expiry Date</label>
          <div className=" costOfInputHeader">
            {bomHeaderData?.batchNumber?.expiryDate ?formatDate(bomHeaderData?.batchNumber?.expiryDate): "-"}
        
        </div>
      </div>
      </>
     :"" }
    </div>
  );
};

export default PrimaryDetails;
